import styled from '@emotion/styled';

const CardRow = styled('div')({
  marginBottom: '1.25rem',
});

export default CardRow;
